import { Box as MuiBox, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { BoxProps };

export const Box: React.ComponentType<BoxProps> = styled(MuiBox)<BoxProps>(() => ({}));
